import React from 'react';
import { Outlet } from 'react-router-dom';
import './Settings.css'
import NavPage from './NavPages';
import SettingsLogic from './SettingsLogic';


function Settings() {
const {activeTab,handleTabChange}=SettingsLogic();

    return (
        <div className="main-content">
            <div className="p-3 mb-1 mt-2 custom-bg-white rounded">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <span className="m-0 title">Settings</span>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <NavPage activeTab={activeTab} handleTabChange={handleTabChange} />
                </div>
                <div className="col-md-9">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default Settings;
